/* Fluido — interacciones propias (mt-*) */
(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var LANG = (document.documentElement.lang || 'es').slice(0, 2) === 'en' ? 'en-GB' : 'es-ES';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isEditor = !!(window.Shopify && window.Shopify.designMode);
  if (isEditor) document.documentElement.classList.add('mt-editor');
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var ease = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
  var easeOut = function (t) { return 1 - Math.pow(1 - t, 3); };
  var vw = function () { return window.innerWidth; };
  var vh = function () { return window.innerHeight; };
  var mobile = function () { return window.innerWidth < 900; };

  /* ---------- bucle único de scroll ---------- */
  var scrollers = [];
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      for (var i = 0; i < scrollers.length; i++) scrollers[i]();
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  function progressOf(el) {
    var r = el.getBoundingClientRect();
    var total = el.offsetHeight - vh();
    return total > 0 ? clamp(-r.top / total, 0, 1) : 0;
  }

  /* ---------- revelados ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }) : null;
  function initReveal(root) {
    (root || document).querySelectorAll('.mt-reveal:not(.mt-visible)').forEach(function (el) {
      if (!io || reduce) el.classList.add('mt-visible'); else io.observe(el);
    });
  }

  /* ---------- cabecera ---------- */
  function initHeader() {
    var h = document.querySelector('[data-mt-header]');
    if (!h || h.dataset.mtInit) return;
    h.dataset.mtInit = '1';
    var last = window.scrollY;
    scrollers.push(function () {
      var y = window.scrollY;
      h.classList.toggle('is-scrolled', y > 30);
      var hideOk = y > 600 && y > last + 4 && !document.querySelector('.mt-hero__copy.is-on:hover');
      if (hideOk) h.classList.add('is-hidden');
      else if (y < last - 4 || y < 600) h.classList.remove('is-hidden');
      last = y;
    });
  }

  /* ---------- héroe: el lápiz pasa de gigante a pequeño ---------- */
  function initHero() {
    document.querySelectorAll('[data-mt-hero]').forEach(function (hero) {
      if (hero.dataset.mtInit) return;
      hero.dataset.mtInit = '1';
      var pen = hero.querySelector('.mt-hero__pen');
      var img = pen && pen.querySelector('img');
      var word = hero.querySelector('.mt-hero__word');
      var copy = hero.querySelector('.mt-hero__copy');
      var intro = hero.querySelector('.mt-hero__intro');
      var startBig = parseFloat(hero.dataset.start || '1.75');
      var mx = 0, my = 0, tx = 0, ty = 0;
      if (!mobile()) {
        hero.addEventListener('mousemove', function (e) {
          var r = hero.getBoundingClientRect();
          mx = ((e.clientX - r.left) / r.width - 0.5);
          my = ((e.clientY - r.top) / r.height - 0.5);
        });
      }
      function frame() {
        var p = reduce ? 1 : progressOf(hero);
        var m = mobile();
        var penH = img ? img.offsetHeight : vw() * 1.5;
        // tramo 1 (0 → 0.62): encoge y gira. tramo 2: quieto + texto
        var t = ease(clamp(p / 0.62, 0, 1));
        var sStart = (m ? vw() * 2.15 : vw() * startBig) / penH;
        var sEnd = (m ? vw() * 0.9 : vh() * 0.78) / penH;
        var s = lerp(sStart, sEnd, t);
        var rot = lerp(90, m ? 97 : -16, t);
        var x = lerp(0, m ? 0 : vw() * 0.2, t);
        var y = lerp(m ? -vh() * 0.02 : 0, m ? vh() * 0.34 : vh() * 0.01, t);
        tx += (mx - tx) * 0.08; ty += (my - ty) * 0.08;
        var tilt = t > 0.95 && !m ? 1 : 0;
        pen.style.transform = 'translate3d(' + (x + tx * 18 * tilt) + 'px,' + (y + ty * 14 * tilt) + 'px,0) rotate(' + (rot + tx * 4 * tilt) + 'deg) scale(' + s + ')';
        hero.style.setProperty('--sx', (100 - p * 160) + '%');
        hero.style.setProperty('--p', p.toFixed(4));
        hero.style.setProperty('--gx', (50 + t * 20) + '%');
        if (word) { word.style.setProperty('--ws', (1 + t * 0.25).toFixed(3)); word.style.setProperty('--wo', (1 - t).toFixed(3)); }
        if (intro) intro.style.setProperty('--io', (1 - clamp(p / 0.18, 0, 1)).toFixed(3));
        var c = easeOut(clamp((p - 0.5) / 0.28, 0, 1));
        if (copy) {
          copy.style.setProperty('--co', c.toFixed(3));
          copy.style.setProperty('--cy', ((1 - c) * 40) + 'px');
          copy.classList.toggle('is-on', c > 0.6);
        }
        if (tilt && (Math.abs(mx - tx) > 0.001 || Math.abs(my - ty) > 0.001)) requestAnimationFrame(frame);
      }
      if (!mobile()) hero.addEventListener('mousemove', function () { requestAnimationFrame(frame); });
      scrollers.push(frame);
      if (img && !img.complete) img.addEventListener('load', frame);
      frame();
    });
  }

  /* ---------- marquesina con inercia del scroll ---------- */
  function initMarquee() {
    document.querySelectorAll('[data-mt-marquee]').forEach(function (m) {
      if (m.dataset.mtInit || reduce) return;
      m.dataset.mtInit = '1';
      var rows = [].slice.call(m.querySelectorAll('.mt-marquee__row'));
      var speed = parseFloat(m.dataset.speed || '40');
      var pos = rows.map(function () { return 0; });
      var lastY = window.scrollY, boost = 0, prev = performance.now(), visible = true;
      if (io) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(m);
      function loop(now) {
        var dt = Math.min(0.05, (now - prev) / 1000); prev = now;
        var y = window.scrollY; boost = boost * 0.9 + (y - lastY) * 0.6; lastY = y;
        if (visible) rows.forEach(function (r, i) {
          var dir = i % 2 ? 1 : -1;
          var half = r.scrollWidth / 2;
          pos[i] += dir * (speed + Math.abs(boost) * 6) * dt;
          if (dir < 0 && pos[i] <= -half) pos[i] += half;
          if (dir > 0 && pos[i] >= 0) pos[i] -= half;
          r.style.transform = 'translate3d(' + pos[i] + 'px,0,0)';
        });
        requestAnimationFrame(loop);
      }
      rows.forEach(function (r, i) { if (i % 2) pos[i] = -r.scrollWidth / 2; });
      requestAnimationFrame(loop);
    });
  }

  /* ---------- manifiesto: palabras que se encienden ---------- */
  function initManifesto() {
    document.querySelectorAll('[data-mt-manifesto]').forEach(function (el) {
      if (el.dataset.mtInit) return;
      el.dataset.mtInit = '1';
      var words = el.querySelectorAll('.w');
      if (reduce) { words.forEach(function (w) { w.classList.add('on'); }); return; }
      scrollers.push(function () {
        var r = el.getBoundingClientRect();
        var start = vh() * 0.85, end = vh() * 0.3;
        var p = clamp((start - r.top) / (start - end + r.height * 0.6), 0, 1);
        var n = Math.round(p * words.length);
        for (var i = 0; i < words.length; i++) words[i].classList.toggle('on', i < n);
      });
      onScroll();
    });
  }

  /* ---------- vídeo que se expande ---------- */
  function initXVideo() {
    document.querySelectorAll('[data-mt-xvideo]').forEach(function (sec) {
      if (sec.dataset.mtInit) return;
      sec.dataset.mtInit = '1';
      var fr = sec.querySelector('.mt-xvideo__frame');
      var v = sec.querySelector('video');
      if (v) { v.muted = true; v.setAttribute('playsinline', ''); }
      scrollers.push(function () {
        var p = reduce ? 1 : progressOf(sec);
        var t = ease(clamp(p / 0.55, 0, 1));
        var m = mobile();
        var ix0 = m ? 12 : 22, iy0 = m ? 30 : 14;
        var maxW = parseFloat(sec.dataset.maxw || '1180');
        var ixEnd = m ? 4 : Math.max(3, (vw() - maxW) / 2 / vw() * 100);
        var iyEnd = m ? 20 : Math.max(5, (vh() - maxW * 0.5) / 2 / vh() * 100);
        sec.style.setProperty('--ix', lerp(ix0, ixEnd, t) + '%');
        sec.style.setProperty('--iy', lerp(iy0, iyEnd, t) + '%');
        sec.style.setProperty('--ir', lerp(32, m ? 22 : 28, t) + 'px');
        sec.style.setProperty('--vs', lerp(1.18, 1, t).toFixed(3));
        sec.style.setProperty('--lo', (1 - t).toFixed(3));
        var c = easeOut(clamp((p - 0.45) / 0.3, 0, 1));
        sec.style.setProperty('--so', c.toFixed(3));
        sec.style.setProperty('--co', c.toFixed(3));
        var r = sec.getBoundingClientRect();
        if (v) { if (r.top < vh() && r.bottom > 0) { if (v.paused) v.play().catch(function () {}); } else if (!v.paused) v.pause(); }
      });
      onScroll();
    });
  }

  /* ---------- modos con autoavance ---------- */
  function initModes() {
    document.querySelectorAll('[data-mt-modes]').forEach(function (sec) {
      if (sec.dataset.mtInit) return;
      sec.dataset.mtInit = '1';
      var btns = [].slice.call(sec.querySelectorAll('.mt-mode'));
      var items = [].slice.call(sec.querySelectorAll('.mt-stage__item'));
      var dur = parseFloat(sec.dataset.dur || '6') * 1000;
      var cur = 0, timer = null, inView = false, started = 0, left = dur;
      function show(i) {
        cur = (i + btns.length) % btns.length;
        btns.forEach(function (b, k) { b.classList.toggle('is-active', k === cur); b.setAttribute('aria-selected', k === cur); });
        items.forEach(function (it, k) {
          it.classList.toggle('is-active', k === cur);
          var v = it.querySelector('video');
          if (v) { if (k === cur && inView) { v.currentTime = 0; v.play().catch(function () {}); } else v.pause(); }
        });
        // reinicia la barra
        var bar = btns[cur].querySelector('.mt-mode__bar');
        if (bar) { bar.style.animation = 'none'; bar.offsetWidth; bar.style.animation = ''; }
        schedule(dur);
      }
      function schedule(ms) {
        clearTimeout(timer); left = ms; started = Date.now();
        if (inView && !reduce && dur > 0) timer = setTimeout(function () { show(cur + 1); }, ms);
      }
      btns.forEach(function (b, k) { b.addEventListener('click', function () { show(k); }); });
      sec.addEventListener('mouseenter', function () { sec.classList.add('is-paused'); clearTimeout(timer); left = Math.max(0, left - (Date.now() - started)); });
      sec.addEventListener('mouseleave', function () { sec.classList.remove('is-paused'); schedule(left || dur); });
      if (io) new IntersectionObserver(function (e) {
        inView = e[0].isIntersecting;
        var v = items[cur] && items[cur].querySelector('video');
        if (inView) { if (v) v.play().catch(function () {}); schedule(left || dur); }
        else { clearTimeout(timer); if (v) v.pause(); }
      }, { threshold: 0.35 }).observe(sec);
      show(0);
    });
  }

  /* ---------- cifras que cuentan ---------- */
  function initCount() {
    document.querySelectorAll('[data-mt-count]').forEach(function (el) {
      if (el.dataset.mtInit) return;
      el.dataset.mtInit = '1';
      var to = parseFloat(el.dataset.mtCount), dec = (el.dataset.mtCount.split('.')[1] || '').length;
      var run = function () {
        if (reduce) { el.textContent = to.toFixed(dec).replace('.', ','); return; }
        var t0 = performance.now(), d = 1800;
        (function step(now) {
          var k = easeOut(clamp((now - t0) / d, 0, 1));
          el.textContent = (to * k).toFixed(dec).replace('.', ',');
          if (k < 1) requestAnimationFrame(step);
        })(t0);
      };
      if (!io) return run();
      var o = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { run(); o.disconnect(); } }, { threshold: 0.5 });
      o.observe(el);
    });
  }

  /* ---------- para quién: scroll horizontal fijado ---------- */
  function initWho() {
    document.querySelectorAll('[data-mt-who]').forEach(function (sec) {
      if (sec.dataset.mtInit) return;
      sec.dataset.mtInit = '1';
      var track = sec.querySelector('.mt-who__track');
      function size() {
        if (mobile()) { sec.style.height = ''; return; }
        var dist = Math.max(0, track.scrollWidth - vw());
        sec.style.height = (vh() + dist) + 'px';
        sec.dataset.dist = dist;
      }
      size();
      window.addEventListener('resize', size);
      window.addEventListener('load', size);
      scrollers.push(function () {
        if (mobile()) return;
        var p = progressOf(sec);
        track.style.transform = 'translate3d(' + (-p * parseFloat(sec.dataset.dist || 0)) + 'px,0,0)';
      });
      onScroll();
    });
  }

  /* ---------- barra de compra fija ---------- */
  function initBuybar() {
    var bar = document.querySelector('[data-mt-buybar]');
    if (!bar || bar.dataset.mtInit) return;
    bar.dataset.mtInit = '1';
    var after = parseFloat(bar.dataset.after || '0.9');
    scrollers.push(function () {
      var hero = document.querySelector('[data-mt-hero]') || document.querySelector('[data-mt-pdp-buy]');
      var show;
      if (hero && hero.hasAttribute('data-mt-hero')) {
        var r = hero.getBoundingClientRect();
        show = r.bottom < vh() * after;
      } else if (hero) {
        show = hero.getBoundingClientRect().bottom < 0;
      } else show = window.scrollY > vh();
      var stop = document.querySelector('[data-mt-cta], .mt-footer');
      if (stop && stop.getBoundingClientRect().top < vh() * 0.85) show = false;
      bar.classList.toggle('is-on', show);
    });
    onScroll();
  }

  /* ---------- galería de producto ---------- */
  function initGallery() {
    document.querySelectorAll('[data-mt-gallery]').forEach(function (g) {
      if (g.dataset.mtInit) return;
      g.dataset.mtInit = '1';
      var slides = [].slice.call(g.querySelectorAll('.mt-gallery__slide'));
      var thumbs = [].slice.call(g.querySelectorAll('.mt-thumb'));
      var stage = g.querySelector('.mt-gallery__stage');
      var cur = 0;
      function show(i) {
        cur = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) {
          s.classList.toggle('is-active', k === cur);
          var v = s.querySelector('video');
          if (v) { if (k === cur) { v.muted = true; v.play().catch(function () {}); } else v.pause(); }
        });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === cur); });
        if (thumbs[cur]) thumbs[cur].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        stage.classList.remove('is-zoom');
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
      var prev = g.querySelector('.mt-gallery__nav--prev'), next = g.querySelector('.mt-gallery__nav--next');
      if (prev) prev.addEventListener('click', function () { show(cur - 1); });
      if (next) next.addEventListener('click', function () { show(cur + 1); });
      // zoom al pasar el ratón (solo fotos, solo ordenador)
      stage.addEventListener('mousemove', function (e) {
        if (mobile() || !slides[cur].querySelector('img') || slides[cur].querySelector('video')) return;
        var r = stage.getBoundingClientRect();
        stage.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
        stage.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
      });
      stage.addEventListener('click', function (e) {
        if (e.target.closest('.mt-gallery__nav') || mobile() || slides[cur].querySelector('video')) return;
        stage.classList.toggle('is-zoom');
      });
      stage.addEventListener('mouseleave', function () { stage.classList.remove('is-zoom'); });
      // deslizar con el dedo
      var x0 = null;
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1));
        x0 = null;
      });
      show(0);
    });
  }

  /* ---------- cantidad ---------- */
  function initQty() {
    document.querySelectorAll('[data-mt-qty]').forEach(function (q) {
      if (q.dataset.mtInit) return;
      q.dataset.mtInit = '1';
      var input = q.querySelector('input');
      q.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value || '1', 10) + parseInt(b.dataset.step, 10);
          input.value = Math.max(1, Math.min(99, v));
          document.querySelectorAll('[data-mt-qty-mirror]').forEach(function (m) { m.value = input.value; });
        });
      });
    });
  }

  /* ---------- FAQ suave ---------- */
  function initFaq() {
    document.querySelectorAll('[data-mt-faq] details').forEach(function (d) {
      if (d.dataset.mtInit || reduce) return;
      d.dataset.mtInit = '1';
      var s = d.querySelector('summary'), a = d.querySelector('.mt-faq__a');
      if (!a) return;
      s.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.open) {
          var h = a.scrollHeight;
          a.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 450, easing: 'cubic-bezier(.22,1,.36,1)' }).onfinish = function () { d.open = false; };
        } else {
          d.open = true;
          var h2 = a.scrollHeight;
          a.animate([{ height: '0px', opacity: 0 }, { height: h2 + 'px', opacity: 1 }], { duration: 550, easing: 'cubic-bezier(.22,1,.36,1)' });
        }
      });
    });
  }


  /* ---------- buscador de idiomas ---------- */
  function initLangs() {
    document.querySelectorAll('[data-mt-langs]').forEach(function (box) {
      if (box.dataset.mtInit) return;
      box.dataset.mtInit = '1';
      var sec = box.closest('section');
      var input = sec.querySelector('[data-mt-lang-input]');
      var out = sec.querySelector('[data-mt-lang-result]');
      var chips = [].slice.call(box.querySelectorAll('.mt-lang'));
      var norm = function (t) { return (t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim(); };
      if (!input) return;
      input.addEventListener('input', function () {
        var q = norm(input.value);
        if (q.length < 2) { box.classList.remove('is-filtering'); chips.forEach(function (c) { c.classList.remove('is-match'); }); out.innerHTML = ''; return; }
        box.classList.add('is-filtering');
        var off = null, on = null;
        chips.forEach(function (c) {
          var hit = norm(c.textContent).indexOf(q) === 0 || norm(c.textContent).indexOf(' ' + q) > -1;
          c.classList.toggle('is-match', hit);
          if (hit) { if (c.classList.contains('mt-lang--off')) off = off || c.textContent; else on = on || c.textContent; }
        });
        var msg = function (k, x) { return '✓ ' + (input.dataset[k] || '').replace('{x}', '<b>' + x + '</b>'); };
        if (off) out.innerHTML = msg('off', off);
        else if (on) out.innerHTML = msg('on', on);
        else out.innerHTML = input.dataset.none || '';
      });
    });
  }

  /* ---------- fecha de entrega estimada ---------- */
  function initEta() {
    document.querySelectorAll('[data-mt-eta]').forEach(function (el) {
      if (el.dataset.mtInit) return;
      el.dataset.mtInit = '1';
      var d = function (n) { var x = new Date(); x.setDate(x.getDate() + n); return x.toLocaleDateString(LANG, { day: 'numeric', month: 'short' }).replace('.', ''); };
      var min = parseInt(el.dataset.min || '20', 10), max = parseInt(el.dataset.max || '29', 10);
      var s = el.querySelectorAll('[data-eta]');
      if (s[0]) s[0].textContent = d(0);
      if (s[1]) s[1].textContent = d(1) + '–' + d(3);
      if (s[2]) s[2].textContent = d(min) + ' – ' + d(max);
    });
  }


  /* ---------- reloj real en la pantalla del lápiz ---------- */
  window.mtClockText = function () {
    var n = new Date();
    var t = n.toLocaleTimeString(LANG, { hour: '2-digit', minute: '2-digit' });
    var d = n.toLocaleDateString(LANG, { weekday: 'long', day: 'numeric', month: 'long' });
    return { t: t, d: d.charAt(0).toUpperCase() + d.slice(1) };
  };
  function initClock() {
    document.querySelectorAll('[data-mt-clock]').forEach(function (c) {
      if (c.dataset.mtInit) return;
      c.dataset.mtInit = '1';
      var img = c.parentNode.querySelector('img');
      var t = c.querySelector('.t'), d = c.querySelector('.d');
      // medidas de la pantalla en la imagen original (1654 px de alto)
      function place() {
        var k = (img.offsetHeight || 0) / 1654;
        if (!k) return;
        c.style.left = (30 * k) + 'px'; c.style.top = (1296 * k) + 'px';
        c.style.width = (1252 * k) + 'px'; c.style.height = (292 * k) + 'px';
        t.style.cssText = 'left:' + 28 * k + 'px;top:' + 18 * k + 'px;font-size:' + 24 * k + 'px;';
        d.style.cssText = 'left:' + 112 * k + 'px;top:' + 22 * k + 'px;font-size:' + 19 * k + 'px;';
      }
      function tick() { var x = window.mtClockText(); t.textContent = x.t; d.textContent = x.d; }
      place(); tick();
      if (!img.complete) img.addEventListener('load', place);
      window.addEventListener('resize', place);
      setInterval(tick, 15000);
    });
  }

  function initAll(e) {
    var root = e && e.target && e.target.querySelectorAll ? e.target : document;
    initReveal(root);
    initHeader();
    initHero();
    initMarquee();
    initManifesto();
    initXVideo();
    initModes();
    initCount();
    initWho();
    initBuybar();
    initGallery();
    initQty();
    initFaq();
    initLangs();
    initEta();
    initClock();
    onScroll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
  window.addEventListener('load', onScroll);
})();
